import { render, staticRenderFns } from "./InternshipDocument.vue?vue&type=template&id=6ec96351&scoped=true"
import script from "./InternshipDocument.vue?vue&type=script&lang=js"
export * from "./InternshipDocument.vue?vue&type=script&lang=js"
import style0 from "./InternshipDocument.vue?vue&type=style&index=0&id=6ec96351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec96351",
  null
  
)

export default component.exports